var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackersGametrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 142",
    style: {
      enableBackground: "new 0 0 200 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0069,
    y1: 80.055,
    x2: 135.5878,
    y2: 120.1382,
    gradientTransform: "matrix(1 0 0 -1 0 144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF41B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#379FFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,64.1c-5.6,0-11-2.2-15-6.2c-4-4-6.2-9.3-6.2-14.9c0-5.6,2.2-11,6.2-14.9c3.6-3.6,8.5-5.8,13.6-6.1v0H87 h38.5L119,33.1H87v0c-2.6,0-5.1,1-7,2.9c-1.9,1.8-2.9,4.4-2.9,7s1,5.1,2.9,7c1.9,1.8,4.4,2.9,7,2.9h13.4v11.3H87z M134.3,37.4 h-15.6v11.5h9.3L134.3,37.4z M103.7,48.9v34.5l11.5-19.1V37.4h-10.2h-1.4H87.4v11.5H103.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.3,90.5h17.8l-2.3,3.7H22.7c-3.1,0-5.6,2.4-5.6,5.1s1.6,5.1,4.9,5.1h5.7l2.2-3.8h-8l1.9-3.2h12.2L30,108 h-7.7c-2.4,0-4.5-0.9-6.2-2.6c-1.7-1.7-2.6-3.8-2.6-6.2s0.9-4.5,2.6-6.2C17.9,91.4,19.9,90.5,22.3,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,100.6l-2.8-4.9L37,108h-4.4l10.3-17.5l3.3,0l9.8,17.5h-4.8l-2-3.7h-7.7l2.1-3.7L47.1,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.1,96.8v5.5l-3.4-6v-5.9h3.9l6.1,10.3l5.9-10.3h4.1V108h-3.9V97l-6.1,11L55.1,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,104.3h11l-2.2,3.7H74.2V90.5h22.5l-2.4,3.9H77.8v3.3h14.8l-2,3.6H77.8V104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.3,94.5V108h-3.5V94.5h-9.2l2.2-3.7h17.4l-3.1,3.7H110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,94.5l-2.3-3.7h11.3c4,0,6.1,1.4,6.1,5.5c0,2.4-2.2,4.1-4.3,4.6l4.3,7.3h-4l-4.7-7.2h-4.4v7.2h-3.5 V96.9h11.4c0.9,0,1.2-0.9,1.2-1.3c0-0.4-0.3-1.2-1.2-1.2H114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,100.8l-3.3-5.6l-6.6,10.6l-1.9-3.3l7.4-11.7l3.3,0L149,108h-4.6l-2.1-3.5h-9l2.4-3.7L140.1,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.1,94.5h-9.7l-2.2-3.7h12.3c4.7,0,9.2,3.9,8.9,8.9c-0.2,5-3.9,8.4-8.9,8.4h-2.2l-4.9-8.5v-3.1h3.5v7.6 h3.6c3.5,0,5-2,5-5C158.6,96.2,155.8,94.5,153.1,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.2,104.6h10.5l-2.2,3.5h-11.7V90.7h21.7l-2.4,3.9h-15.8v3.2h14l-2,3.4h-12V104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,120.1l0-4.5l-2.2,3.7h-0.8l-2.2-3.6v4.4h-1.6v-7.4h1.4l2.8,4.6l2.7-4.6h1.4l0,7.4H22.6z M52.2,118.6 h-3.5l-0.7,1.6h-1.8l3.3-7.4h1.7l3.3,7.4h-1.8L52.2,118.6z M51.6,117.2l-1.2-2.8l-1.2,2.8H51.6z M81.4,120.1l-1.4-2.1h-0.1h-1.5 v2.1h-1.7v-7.4h3.2c0.7,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.1,0.9c0.3,0.4,0.4,0.9,0.4,1.4s-0.1,1-0.4,1.4 c-0.3,0.4-0.6,0.7-1.1,0.9l1.7,2.4H81.4z M81.4,115.4c0-0.4-0.1-0.7-0.4-1c-0.3-0.2-0.7-0.3-1.2-0.3h-1.4v2.6h1.4 c0.5,0,0.9-0.1,1.2-0.3C81.2,116.1,81.4,115.8,81.4,115.4z M108.4,117.2l-1,1v1.9h-1.7v-7.4h1.7v3.5l3.3-3.5h1.9l-3.1,3.3l3.3,4.1 h-2L108.4,117.2z M140.6,118.8v1.4h-5.8v-7.4h5.6v1.4h-3.9v1.6h3.5v1.3h-3.5v1.7H140.6z M164.7,114.1h-2.4v-1.4h6.5v1.4h-2.4v6 h-1.7V114.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackersGametrade);
export default __webpack_public_path__ + "static/media/backers-gametrade.23c451cfcbcb331f96d92ef9344b9368.svg";
export { ForwardRef as ReactComponent };